import {AngularFirestore} from "@angular/fire/firestore";
import {ResourceChat} from "../../domain/resources/chat/ResourceChat";
import {AbstractFirestoreRepository} from "./AbstractFirestoreRepository";
import {Injectable} from "@angular/core";

import {from, Observable} from "rxjs";
import {firestore} from "firebase";
import {classToPlain} from "class-transformer";
import {ResourceChatMessage} from "../../domain/resources/chat/ResourceChatMessage";

@Injectable({
	providedIn: 'root',
} as any)
export class ResourceChatRepository extends AbstractFirestoreRepository<ResourceChat> {


	constructor(protected db:AngularFirestore) {
		super(ResourceChat, db, db.collection("Chats").doc("resource").collection("Chats"), "resourceGuid");
	}

	public ensureChat$(resourceGuid:string):Observable<void> {
		return from(this.collection.doc<any>(resourceGuid).set({resourceGuid}, {merge:true}));
	}

	public appendMessage$(resourceGuid:string, message:ResourceChatMessage):Observable<void> {
		return from(this.collection.doc<any>(resourceGuid).set({
			resourceGuid,
			messages: firestore.FieldValue.arrayUnion(classToPlain(message))
		}, {merge:true}));
	}

}
